import BaseModal from '../../BaseModal'

export const ViewDataModal = ({ open, handleClose, viewDataItems }) => {
  return (
    <BaseModal config={{ open, handleClose }}>
      <button onClick={handleClose}>Close View Data Modal</button>
    </BaseModal>
  )
}

export default ViewDataModal
